// Port of api/fuel/app/classes/insights/size/activity.php

import Segment from 'offline/insights/segment'
import Constants from 'offline/constants'
import Util from 'offline/util'
import Config from 'offline/model/config'

function excludeExpansions(ownerId) {
	var config = Config.user(ownerId)
	return !!(((config || {}).insights || {}).size || {}).expansions
}

function monthStartFor(year, month) {
	var date = new Date(Date.UTC(year, month - 1, 1, 0, 0, 0))
	return Math.floor(date.getTime() / 1000)
}

function monthEndFor(year, month) {
	var date = new Date(Date.UTC(year, month, 0, 23, 59, 59))
	return Math.floor(date.getTime() / 1000)
}

function monthStartOffset(base, monthOffset) {
	var date = new Date(base * 1000)
	date.setUTCDate(1)
	date.setUTCHours(0, 0, 0, 0)
	date.setUTCMonth(date.getUTCMonth() + monthOffset)
	return Math.floor(date.getTime() / 1000)
}

function monthEndTimestamp(base) {
	var date = new Date(base * 1000)
	date.setUTCMonth(date.getUTCMonth() + 1, 0)
	date.setUTCHours(23, 59, 59, 0)
	return Math.floor(date.getTime() / 1000)
}

export default Segment.extend({
	name: 'activity',
	types: [Constants.TYPE_USER],
	insight: ['activity.expansions', 'activity.period'],
	detail: ['activity'],
	run: function(type, owner, userIndex, detail, filter, vars) {
		if (!owner.get_count_collection()) return {}

		var exclude = excludeExpansions(vars && vars.sessionUserId)
		var period = (filter && filter['activity.period'] !== undefined) ? parseInt(filter['activity.period'], 10) : 0

		if (detail) {
			var games = []
			var parts = String(vars.index).split('/')
			var year = 0
			var month = 0

			if (parts.length === 1) {
				year = parseInt(parts[0], 10)
				month = 0
			} else {
				month = parseInt(parts[0], 10)
				year = parseInt(parts[1], 10) + 2000
			}

			var start = month ? monthStartFor(year, month) : monthStartFor(year, 1)
			var end = month ? monthEndFor(year, month) : monthEndFor(year, 12)
			var gameTrack = {}
			var logs = Util.queryFast(
				'SELECT g.game_name AS n, g.game_type AS t, l.log_date AS d, l.log_context AS c, l.game_id AS g' +
				' FROM log_user_collection l, game g' +
				' WHERE l.user_id = ' + owner.get_id() +
				' AND l.game_id = g.game_id' +
				' AND l.log_date >= ' + start +
				' AND l.log_initial_sync = 0' +
				' AND l.log_date <= ' + end +
				(exclude ? ' AND g.game_type = 1' : '') +
				' ORDER BY g.game_sortname ASC'
			)

			for (var i = 0; i < logs.length; i++) {
				var log = logs[i]
				var gameId = parseInt(log.g, 10)
				if (!gameTrack[gameId]) {
					gameTrack[gameId] = {
						id: gameId,
						t: parseInt(log.t, 10),
						added: 0,
						removed: 0,
						name: log.n
					}
				}
				gameTrack[gameId][parseInt(log.c, 10) === Constants.LOG_CONTEXT_ADDED ? 'added' : 'removed'] = parseInt(log.d, 10)
			}

			var ids = Object.keys(gameTrack)
			for (var j = 0; j < ids.length; j++) {
				var game = gameTrack[ids[j]]
				this._references.games.push(game.id)
				games.push({
					id: game.id,
					added: game.added,
					removed: game.removed
				})
			}

			return {
				games: games
			}
		}

		var activity = []
		var periodCount = period === 0 ? 120 : 12
		var time = Math.floor(Date.now() / 1000)
		var currentMonth = period > 1 ? monthStartFor(parseInt(period, 10), 12) : time
		var monthStart = monthStartOffset(currentMonth, 0 - periodCount)
		var monthEnd = monthEndTimestamp(currentMonth)
		var rows = Util.queryFast(
			'SELECT * FROM insight_user_collection WHERE user_id = ' + owner.get_id() +
			' AND insight_date >= ' + monthStart +
			' AND insight_date <= ' + monthEnd +
			' ORDER BY insight_date ASC'
		)
		var byStamp = {}

		for (var r = 0; r < rows.length; r++) byStamp[rows[r].insight_stamp] = rows[r]

		for (var k = periodCount; k >= 1; k--) {
			var stamp = Util.date('m.y', currentMonth)
			if (byStamp[stamp]) {
				activity.push({
					period: Util.date('m/y', currentMonth),
					added: parseInt(byStamp[stamp][exclude ? 'insight_count_base_added' : 'insight_count_added'], 10) || 0,
					removed: parseInt(byStamp[stamp][exclude ? 'insight_count_base_removed' : 'insight_count_removed'], 10) || 0,
					size: parseInt(byStamp[stamp][exclude ? 'insight_count_base' : 'insight_count'], 10) || 0
				})
			}
			currentMonth = monthStartOffset(currentMonth, -1)
		}

		activity = activity.reverse()
		var years = []
		var currentYear = new Date().getUTCFullYear()
		var firstYear = owner.get_date_sync_first ? parseInt(Util.date('Y', owner.get_date_sync_first() || time), 10) : currentYear
		if (!firstYear) firstYear = currentYear
		for (var y = currentYear; y >= firstYear; y--) years.push(y)

		if (period === 0) {
			var newActivity = {}
			for (var a = 0; a < activity.length; a++) {
				var activityYear = parseInt(String(activity[a].period).split('/')[1], 10) + 2000
				if (!newActivity[activityYear]) newActivity[activityYear] = { period: activityYear, added: 0, removed: 0, size: 0 }
				newActivity[activityYear].added += activity[a].added
				newActivity[activityYear].removed += activity[a].removed
				newActivity[activityYear].size = activity[a].size
			}
			activity = Object.keys(newActivity).sort().map(function(yearKey) { return newActivity[yearKey] })
		}

		return {
			activity: {
				data: activity,
				years: years
			}
		}
	}
})
